import {ChangeEvent} from 'react';

export enum TabsEnum {
    visualQc = 'Video/Audio',
    metadata = 'Metadata',
    artwork = 'Artwork',
    rights = 'Rights',
    report = 'Validation',
    none = '',
}

export type SetCurrentTab = (value: TabsEnum) => void;
export type HandleChange = (event: ChangeEvent<{}>, newValue: TabsEnum) => void;

export interface DeliveryJobsStatusPayload {
    isDeliveryStarted: boolean;
    deliveryStartedAt: string;
}
